export default __webpack_public_path__ + "static/media/sch3_w320.99c9a4d4.jpg";